import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { ContentMessage, ErrorPage } from 'axway-react-ui';

class AwaitRestartView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		const {
			restarting,
			timeout,
			error,
			errorDetail,
			onRetry
		} = this.props;
		const retryMessage = this.intl.formatMsg('Try again');
		if (error) {
			return (
				<ErrorPage
					modal
					className="lg error"
					errorDetail={errorDetail}
					onAction={onRetry}
					actionLabel={retryMessage}
					imgClass="gg icon-GG-cloud-cross "
				/>
			);
		} else if (timeout) {
			const documentation = this.intl.formatMsg('API Builder documentation');
			const summary = this.intl.formatHTMLMsg('Read the {href} for more information', { href: <a href={window.$conf.docUIUrl}>{documentation}</a> });
			return (
				<ContentMessage
					className="lg error timeout"
					imgClass="gg icon-GG-cloud-cross "
					title={this.intl.formatMsg('Server restart failure')}
					summary={summary}
					detail={this.intl.formatMsg('Review your recent changes to the system and the API Builder logs for more information.')}
					actionLabel={retryMessage}
					onAction={onRetry}
				/>
			);
		} else if (restarting) {
			return (
				<ContentMessage
					className="await-restart-view"
					imgClass="gg icon-GG-cloud-lightning "
					summary={this.intl.formatMsg('Restarting the server...')}
				/>
			);
		}
		return null;
	}
}

AwaitRestartView.propTypes = {
	onRetry: PropTypes.func.isRequired,
	restarting: PropTypes.bool,
	timeout: PropTypes.bool,
	error: PropTypes.bool,
	errorDetail: PropTypes.object
};

export default injectIntl(AwaitRestartView);
